/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Publication readership band used for pricing.
 */
export type PublicationAudience = typeof PublicationAudience[keyof typeof PublicationAudience];


export const PublicationAudience = {
  general: 'general',
  child: 'child',
} as const;
